import React, { useState } from "react";
import "../../assets/css/Deals/DealsDynamic.css";
import { getDealStatusBadgeClass } from "../Common/DealStatus";
import FollowUpModal from "../FollowUp/FollowUpModal";

import {
  FaMoneyBillWave,
  FaCalendarAlt,
  FaPhoneAlt,
  FaUserTie,
  FaBriefcase,
} from "react-icons/fa";
import { MdBusiness } from "react-icons/md";

export default function DealsDynamic({
  deals = [],
  title = "Deals",
  onDealClick,
  onFollowupSuccess,
}) {
  const [selectedDealForFollowup, setSelectedDealForFollowup] = useState(null);

  const isTerminalDealStatus = (status) => {
    if (!status) return false;
    const s = String(status).toLowerCase().trim();
    return (
      s === "won" ||
      s === "won close" ||
      s === "closed won" ||
      s === "lost" ||
      s === "deal lost" ||
      s === "closed lost" ||
      s === "closed" ||
      s === "close" ||
      s.includes("won") ||
      s.includes("lost") ||
      s.includes("close")
    );
  };

  return (
    <div className="dl-wrap">
      {/* TOPBAR */}
      <div className="dl-topbar">
        <div className="dl-topbar-left">
          <h2>{title}</h2>
          <span className="dl-count">{deals.length}</span>
        </div>
      </div>

      {/* GRID */}
      <div className="dl-grid">
        {deals.length === 0 ? (
          <div className="dl-empty-state">
            <div className="dl-empty-icon">
              <FaBriefcase />
            </div>
            <h4>No deals assigned.</h4>
            <p>There are currently no active deals associated with this record.</p>
          </div>
        ) : (
          deals.map((deal) => {
            const statusClass =
              deal.status === "Won" || deal.status === "Won Close"
                ? "won"
                : deal.status === "Lost" || deal.status === "Deal Lost"
                  ? "lost"
                  : "open";

            const isTerminal = isTerminalDealStatus(deal.status);

            return (
              <div
                className="dl-card"
                key={deal.id}
                onClick={() => onDealClick?.(deal)}
              >
                {/* HEADER */}
                <div className="dl-card-head">
                  <div className="dl-head-left">
                    <div className="dl-avatar">
                      {deal.title?.charAt(0) || "D"}
                    </div>

                    <div className="dl-title-block">
                      <div className="dl-title-row">
                        <h3>{deal.title || "Untitled Deal"}</h3>
                        {(deal.organization_name || deal.organization?.name) && (
                          <span className="dl-org-badge" title="Organization">
                            <MdBusiness className="dl-org-badge-icon" />
                            <span>{deal.organization_name || deal.organization?.name}</span>
                          </span>
                        )}
                      </div>
                      <p>{deal.status || "No status"}</p>
                    </div>
                  </div>

                  <span
                    className={`status-badge ${getDealStatusBadgeClass(deal.status)} ${statusClass}`}
                  >
                    <span className="dl-status-dot"></span>
                    {deal.status || "-"}
                  </span>
                </div>

                {/* CHIPS */}
                <div className="dl-chips">
                  {(deal.organization_name || deal.organization?.name) && (
                    <span className="dl-chip-org" title="Organization">
                      <MdBusiness className="dl-chip-icon" />{" "}
                      {deal.organization_name || deal.organization?.name}
                    </span>
                  )}

                  <span className="dl-chip-amount">
                    <FaMoneyBillWave className="dl-chip-icon" />{" "}
                    {"₹"}
                    {Number(deal.deal_amount || 0).toLocaleString("en-US")}
                  </span>

                  {deal.expected_close_date && (
                    <span title="Expected Close Date">
                      <FaCalendarAlt className="dl-chip-icon" />
                      {new Date(deal.expected_close_date).toLocaleDateString("en-US")}
                    </span>
                  )}

                  {deal.contact_name && (
                    <span title="Contact Person">
                      <FaUserTie className="dl-chip-icon" /> {deal.contact_name}
                    </span>
                  )}
                </div>

                {/* DESCRIPTION */}
                <div className="dl-desc">
                  {deal.description || deal.lead?.description || "No description provided"}
                </div>

                {/* FOOTER */}
                <div className="dl-footer">
                  <span>
                    <FaCalendarAlt className="dl-footer-icon" />
                    Created:{" "}
                    {deal.created_at
                      ? new Date(deal.created_at).toLocaleDateString("en-US")
                      : "Not available"}
                  </span>

                  {!isTerminal && (
                    <button
                      type="button"
                      className="dl-followup-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedDealForFollowup(deal);
                      }}
                      title="Log / View Follow Up"
                    >
                      <FaPhoneAlt size={10} />
                      <span>Follow Up</span>
                    </button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* FOLLOW UP MODAL */}
      {selectedDealForFollowup && (
        <FollowUpModal
          type="deal"
          id={selectedDealForFollowup.id}
          deal={selectedDealForFollowup}
          dealValue={selectedDealForFollowup.deal_amount}
          isOpen={Boolean(selectedDealForFollowup)}
          onClose={() => setSelectedDealForFollowup(null)}
          onSuccess={async () => {
            setSelectedDealForFollowup(null);
            onFollowupSuccess?.();
          }}
        />
      )}
    </div>
  );
}